/**
 * off canvas module
 * @module twt.off-canvas
 */

import pubSub from './pubSub';

/**
 * @class OffCanvas
 * @export
 */
export default class OffCanvas {
  /**
   * Creates a new instance of an off canvas element.
   * @param {HTMLElement} element - HTMLElement to make into an off canvas.
   * @param {Object} options - Overrides for the default settings.
   */
  constructor(element, options) {
    this.element = element;
    this.options = Object.assign(OffCanvas.defaults, options);
    this.intScrollTop = null;
    this.onTransitionEnd = this.onTransitionEnd.bind(this);

    // initialize
    this.init();
  }

  /**
   * @return {void}
   */
  init() {
    const id = this.element.id;

    // triggers
    this.triggers = [].slice.call(document.querySelectorAll(`[data-open="${id}"], [data-close="${id}"], [data-toggle="${id}"]`));

    for (let i = 0; i < this.triggers.length; i += 1) {
      this.triggers[i].setAttribute('aria-controls', id);
      this.triggers[i].setAttribute('aria-expanded', false);
    }

    // keys
    this.keys = {
      27: this.close.bind(this),
    };

    // register event listener
    this.registerEventListener();

    pubSub.subscribe('close.modules', () => {
      this.close();
    });
  }

  /**
   * @return {void}
   */
  open() {
    const event = document.createEvent('Event');
    event.initEvent('opened.twt.OffCanvas', true, false);

    // add class
    this.element.classList.add(this.options.openClass);

    // set trigger attribute
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', true);
    });

    // add class on body to indicate an open off-canvas
    this.intScrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    document.querySelector('.page-header .search').classList.remove('is--open');
    document.querySelector('.page-header .meta-search .btn').classList.remove('is--active');

    // dispatch event
    this.element.dispatchEvent(event);
    pubSub.publish('opened.offCanvas');
  }

  /**
   * @return {void}
   */
  close() {
    // remove class
    this.element.classList.remove(this.options.openClass);

    // set trigger attribute
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', false);
      trigger.classList.remove(this.options.activeClass);
    });

    // remove class on body to indicate an open off-canvas
    document.body.classList.remove(this.options.openOffCanvasClass);
    document.querySelector('.main-navigation').addEventListener('transitionend', this.onTransitionEnd);

    pubSub.publish('closed.offCanvas');
  }

  /**
   * @return {void}
   */
  onTransitionEnd() {
    // document.body.classList.remove('has--fixed-content');
    document.body.removeAttribute('style');
    document.body.scrollTop = this.intScrollTop;
    document.documentElement.scrollTop = this.intScrollTop;
    document.querySelector('.page-header').style.transform = 'none';
    setTimeout(() => {
      document.querySelector('.page-header').removeAttribute('style');
      document.querySelector('.main-navigation').removeEventListener('transitionend', this.onTransitionEnd);
    }, 50);
  }

  /**
   * @return {void}
   */
  toggle() {
    if (this.element.classList.contains(this.options.openClass)) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * @return {void}
   */
  registerEventListener() {
    // triggers
    for (let i = 0; i < this.triggers.length; i += 1) {
      this.triggers[i].addEventListener('click', (event) => {
        if (event.target.hasAttribute('data-toggle')) {
          this.toggle();
        } else if (event.target.hasAttribute('data-close')) {
          this.close();
        } else {
          this.open();
        }
      });
    }

    // keys
    document.addEventListener('keydown', (event) => {
      const key = event.keyCode;

      if (key in this.keys) {
        this.keys[key]();
      }
    });
  }
}

OffCanvas.defaults = {
  openClass: 'is--open',
  activeClass: 'is--active',
  openOffCanvasClass: 'open-off-canvas',
};



// WEBPACK FOOTER //
// ./assets/js/components/twt.off-canvas.js